<div class="container-fluid">
    <div class="row">
        <div class="modal-header border-0 offset-md-10 col-md-2">
            <button mat-button mat-dialog-close type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
    </div>
    <div class="container-fluid pb-5 h-100">
        <app-expandible-title [title]="'Atualização'"></app-expandible-title>
            <div class="card mb-3 bg-2">
                <div class="card-body">
                    <div>
                        <div *ngFor="let ident of alteracoes.identificadores">
                            <span class="font-weight-bold">{{ident.chave}}: </span>{{ident.valor}}
                        </div>
                    </div>
                    <hr/>
                    <table
                        class="table label-maps table-striped table-bordered table-hover table-responsive-sm table-responsive-md table-responsive-xl">
                        <thead>
                        <tr>
                            <th>Propriedade</th>
                            <th>Anterior</th>
                            <th>Atual</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let property of alteracoes.propriedades">
                            <td>{{property.nome}}</td>
                            <td class="red" *ngIf="!isListWithExcept(property.anterior)">{{convertValues(property.anterior)}}</td>
                            <td class="green" *ngIf="!isListWithExcept(property.atual)">{{convertValues(property.atual)}}</td>
                            <td class="red" *ngIf="isListWithExcept(property.anterior)">
                                <ul>
                                    <li *ngFor="let item of property.anterior.items">{{item.nome}}</li>
                                </ul>
                                <br/>
                                Exceto: {{convertValues(property.anterior.except)}}
                            </td>
                            <td class="green" *ngIf="isListWithExcept(property.atual)">
                                <ul>
                                    <li *ngFor="let item of property.atual.items">{{item.nome}}</li>
                                </ul>
                                <br/>
                                Exceto: {{convertValues(property.atual.except)}}
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
    </div>
</div>
